export interface DeleteSystemOperationMenuRequest {
  id: string
  revision: number
}

export function DeleteSystemOperationMenuRequestToJSON(
  value: DeleteSystemOperationMenuRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
